// src/pages/UsersPage.jsx
import React from 'react';
import UserList from '../components/users/UserList';

const UsersPage = () => {
  return <UserList />;
};

export default UsersPage;